/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'createAccountWorker',
    message: messages.SUCCESS_CREATE_ACCOUNT_WORKER,
    method: 'POST',
    path: '/account/:accountId/worker',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.CREATE_ACCOUNT_WORKER,
    requestSchema: requestSchemas.accountWorkers.createAccountWorker,
  },
  {
    action: 'getAccountWorkers',
    message: messages.SUCCESS_GET_ACCOUNT_WORKERS,
    method: 'GET',
    path: '/account/:accountId/workers',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_ACCOUNT_WORKER,
    requestSchema: requestSchemas.accountWorkers.getAccountWorkers,
    scopes: [scopes.DEFAULT],
  },
  {
    action: 'recoverAccountWorkers',
    message: messages.SUCCESS_RECOVER_ACCOUNT_WORKERS,
    method: 'PATCH',
    path: '/account/:accountId/workers/recover',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.RECOVER_ACCOUNT_WORKER,
    requestSchema: requestSchemas.accountWorkers.recoverAccountWorkers,
  },
  {
    action: 'removeAccountWorkers',
    message: messages.SUCCESS_REMOVE_ACCOUNT_WORKERS,
    method: 'PATCH',
    path: '/account/:accountId/workers/remove',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.REMOVE_ACCOUNT_WORKER,
    requestSchema: requestSchemas.accountWorkers.removeAccountWorkers,
  },
  {
    action: 'updateAccountWorkerById',
    message: messages.SUCCESS_UPDATE_ACCOUNT_WORKER_BY_ID,
    method: 'PATCH',
    path: '/account/:accountId/worker/:objectId',
    payloadType: 'resource',
    permissionIdentity: permissionIdentities.UPDATE_ACCOUNT_WORKER,
    requestSchema: requestSchemas.accountWorkers.updateAccountWorkerById,
  },
];
